/**
 * handle decimal numbers
 * @param num
 * @returns {number}
 * @description convert number to decimal with like 292.8282 to 292.83
 */
export function decimalNumber(num) {
  if (typeof num !== 'number') return num;
  return Math.round(num * 100) / 100;
}

/**
 * convert duration string to seconds
 * @param {string} duration string
 * @return {number} seconds duration in seconds
 */
export function convertDurationStringToSeconds(duration) {
  var seconds = 0;
  var days = duration.match(/(\d+)\s*d/);
  var hours = duration.match(/(\d+)\s*h/);
  var minutes = duration.match(/(\d+)\s*m/);
  if (days) {
    seconds += parseInt(days[1], 10) * 86400;
  }
  if (hours) {
    seconds += parseInt(hours[1], 10) * 3600;
  }
  if (minutes) {
    seconds += parseInt(minutes[1], 10) * 60;
  }
  return seconds;
}

/**
 * move it to core
 * @param dateTime
 * @returns {string}
 */
export function addPrefixZeroToDateTime(dateTime) {
  var prefix = dateTime < 10 ? '0' : '';
  return "" + prefix + dateTime;
}

/**
 * format number
 * @param {number | string} input
 * @return {string}
 */
export function formatNumber(input) {
  if (!['number', 'string'].includes(typeof input)) return '';
  var _input$toString$split = input.toString().split('.'),
    integer = _input$toString$split[0],
    _input$toString$split2 = _input$toString$split[1],
    fraction = _input$toString$split2 === void 0 ? '' : _input$toString$split2;
  return [integer.replace(/\B(?=(\d{3})+(?!\d))/g, ','), fraction.substr(0, 2)].filter(Boolean).join('.');
}

/**
 * convert and format
 * @param price
 * @param decimal
 * @returns {string}
 * @description convert & format
 */
export function formatPriceWithDecimals(_ref) {
  var price = _ref.price,
    _ref$decimal = _ref.decimal,
    decimal = _ref$decimal === void 0 ? 2 : _ref$decimal,
    currentCurrency = _ref.currentCurrency;
  if (typeof price !== 'number') {
    return price;
  }
  decimal = currentCurrency === 'KWD' ? 2 : decimal;
  var decimalValue = typeof decimal !== 'number' || decimal < 0 ? 2 : decimal;
  var decimalNum = decimalNumber(price);
  if (decimalValue === 0) {
    return formatPrice(Math.round(decimalNum));
  }
  return formatPrice(decimalNum.toFixed(decimalValue));
}

/**
 * ceil and format price
 * @param price
 * @param decimals
 */
export function ceilAndFormatPrice(_ref2) {
  var price = _ref2.price,
    _ref2$decimals = _ref2.decimals,
    decimals = _ref2$decimals === void 0 ? 0 : _ref2$decimals;
  return decimals > 0 ? formatPrice(decimalNumber(price).toFixed(decimals)) : formatPrice(Math.ceil(decimalNumber(price)).toFixed(decimals));
}

/**
 * Format price
 * @param price
 * @return {number} converted price
 */
export function formatPrice(price) {
  if (typeof price !== 'number' && typeof price !== 'string') {
    return '';
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function formatPriceOnlyValue(price, decimal) {
  if (decimal === void 0) {
    decimal = 2;
  }
  if (typeof price !== 'number') {
    return price;
  }
  var decimalValue = typeof decimal !== 'number' || decimal < 0 ? 2 : decimal;
  var decimalNum = decimalNumber(price);
  if (decimalValue === 0) {
    return formatPrice(Math.round(decimalNum));
  }
  return formatPrice(decimalNum.toFixed(decimalValue));
}